var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRainbowSixSiegeLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "68px",
    height: "138px",
    viewBox: "0 0 68 138",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 154.162091 190.000906 L 154.162091 603.959834 C 154.162091 603.959834 147.485462 702.985847 300.373352 699.619622 C 300.373352 699.619622 437.884239 716.190472 455.198503 607.256652 L 455.198503 344.170545 C 455.198503 344.170545 444.560868 290.362998 350.863199 290.362998 C 350.863199 290.362998 286.4147 289.026919 283.110979 309.64071 L 282.436398 205.981799 C 282.436398 205.981799 303.071679 182.713202 329.622523 206.641163 L 328.947942 268.465183 L 455.198503 268.465183 L 455.198503 190.000906 C 455.198503 190.000906 454.904455 85.040619 306.548369 90.974892 C 306.496478 90.974892 165.491604 79.03694 154.162091 190.000906 Z M 154.162091 190.000906 ",
    transform: "matrix(0.225834,0,0,0.225122,-34.803383,-20.14845)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 253.187226 433.878708 L 253.187226 623.914261 L 249.330003 623.914261 L 249.330003 634.134398 L 259.431432 634.134398 L 259.431432 637.865008 L 289.718421 637.865008 L 289.718421 633.700606 L 293.765911 633.700606 L 293.765911 534.865461 C 293.765911 534.865461 304.714891 520.480922 330.054947 523.656278 L 330.054947 472.017691 C 330.054947 472.017691 352.091283 460.687047 392.912125 460.687047 L 392.912125 413.438434 C 392.912125 413.438434 377.725388 391.835598 342.47417 415.954427 C 342.47417 415.954427 302.206831 437.991055 293.696723 413.264917 L 260.46925 413.264917 L 260.46925 416.561736 L 252.99696 416.561736 L 252.99696 423.537109 L 249.399191 423.537109 L 249.399191 431.258605 L 253.066148 431.258605 Z M 253.187226 433.878708 ",
    transform: "matrix(0.225834,0,0,0.225122,-34.803383,-20.14845)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 296.948553 490.427819 L 296.948553 519.509228 L 326.630148 519.509228 L 326.630148 479.235988 L 322.461579 471.948285 L 315.61198 471.948285 L 315.78495 478.802197 C 315.78495 478.802197 322.824815 480.034166 323.689664 484.441491 L 321.060525 486.940132 C 321.112416 486.888077 313.519047 475.505378 296.948553 490.427819 Z M 296.948553 490.427819 ",
    transform: "matrix(0.225834,0,0,0.225122,-34.803383,-20.14845)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRainbowSixSiegeLogo);
export default __webpack_public_path__ + "static/media/rainbow-six-siege-logo.f107b0f48ffc84eb8820cba6ecc719b6.svg";
export { ForwardRef as ReactComponent };